import React, { Component } from 'react'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import deviceHelper from 'shared/tools/device-helper'

import LayoutRow from 'client/shared/blocks/layout-row'
import { LayoutColumn } from 'client/shared/blocks/layout-column'

import './layout-user-section.styl'

type Props = {
  firstColumn: React.ReactNode
  secondColumn: React.ReactNode
} & DecoratorProps

class LayoutUserSection extends Component<Props> {
  render() {
    const { firstColumn, secondColumn, app } = this.props

    return (
      <div className="layout-user-section">
        <LayoutRow>
          <LayoutColumn size={deviceHelper.isDesktopSize(app) ? 2 : 4}>
            {firstColumn}
          </LayoutColumn>
          <LayoutColumn size={8}>{secondColumn}</LayoutColumn>
          <LayoutColumn size={deviceHelper.isDesktopSize(app) ? 2 : 4} />
        </LayoutRow>
      </div>
    )
  }
}

export default uiBox(LayoutUserSection)
